import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/docs/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "introduction"
    }}>{`Introduction`}</h1>
    <p>{`Entur provides an API for uploading and downloading NeTEx timetable datasets. These endpoints have restricted access and require a service account (OAuth2) provided by Entur.`}</p>
    <h2 {...{
      "id": "getting-access-to-the-api"
    }}>{`Getting access to the API`}</h2>
    <p>{`Please contact Entur at `}<a parentName="p" {...{
        "href": "mailto:kollektivdata@entur.org"
      }}>{`kollektivdata@entur.org`}</a>{` to get access to the API.`}</p>
    <p>{`You will be granted dedicated OAuth2 credentials ("client-id" and "client-secret") that will allow you to access the service.`}</p>
    <h2 {...{
      "id": "entur-authentication-and-authorization-service"
    }}>{`Entur authentication and authorization service`}</h2>
    <p>{`The endpoints are protected by an OAuth2 authorization layer. Once you receive OAuth2 credentials, you will be able to request access tokens from Entur authorization server using the following parameters:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Env`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`OAuth2 token URI`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`OAuth2 audience / Base URI`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Dev`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://partner.dev.entur.org/oauth/token"
            }}>{`https://partner.dev.entur.org/oauth/token`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://api.dev.entur.io"
            }}>{`https://api.dev.entur.io`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Staging`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://partner.staging.entur.org/oauth/token"
            }}>{`https://partner.staging.entur.org/oauth/token`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://api.staging.entur.io"
            }}>{`https://api.staging.entur.io`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Prod`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://partner.entur.org/oauth/token"
            }}>{`https://partner.entur.org/oauth/token`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://api.entur.io"
            }}>{`https://api.entur.io`}</a></td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "api-reference"
    }}>{`API reference`}</h2>
    <p>{`Please refer to `}<a parentName="p" {...{
        "href": "/pages-timetable-partner"
      }}>{`the API page`}</a>{` for API documentation.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      